import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotifyService } from '@common/services/notify.service';
import { SysLoginService } from 'app/sys-login/sys-login.service';
import { catchError, map, throwError } from 'rxjs';

function sanitizeKeys(obj: any): any {
  if (obj === null || obj === undefined) {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(item => sanitizeKeys(item));
  }
  if (typeof obj === 'object') {
    const newObj: any = {};
    for (const key of Object.keys(obj)) {
      let cleanKey = '';
      for (let i = 0; i < key.length; i++) {
        const code = key.charCodeAt(i);
        if (code >= 32 && code < 127) {
          cleanKey += key.charAt(i);
        }
      }
      newObj[cleanKey] = sanitizeKeys(obj[key]);
    }
    return newObj;
  }
  return obj;
}

export const apiResponseInterceptor: HttpInterceptorFn = (req, next) => {
  const notifyService = inject(NotifyService);
  const router = inject(Router);
  const loginService = inject(SysLoginService);

  return next(req).pipe(
    map(event => {
      if (event instanceof HttpResponse && event.status >= 200 && event.status < 300 && event.body) {
        return event.clone({ body: sanitizeKeys(event.body) });
      }
      return event;
    }),
    catchError((err: HttpErrorResponse) => {
      if (!(err.error instanceof ErrorEvent) && !loginService.tokenValid) {
        notifyService.showToast({
          detail: 'Sua sessão expirou. Faca o login novamente',
          severity: 'error',
        });
        router.navigate(['/acesso']);
      }
      return throwError(() => err);
    }),
  );
};
